// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"6b66137d8e182c8d","888":"d040e56902136311"}[chunkId] + ".css";
};